export const NEFI_ERROR = {
  FORM_FIELD: 1,
  MIN_EXPERT: 2,
  MIN_BRANCH_EXPERT: 3,
};

export const NEFI_ERROR_MESSAGE = 'Bitte füllen Sie alle (rotmarkierten) Pflichtfelder aus.';
